// Debug helper utilities for Stripe payment debugging
export const debugStripe = {
  // Set breakpoints in your code using this function
  breakpoint: (label: string, data?: any) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`🔴 BREAKPOINT: ${label}`, data);
      // This will create a breakpoint in the debugger
      debugger;
    }
  },

  // Log Stripe operations for debugging
  logStripeOperation: (operation: string, data?: any) => {
    if (process.env.NODE_ENV === 'development') {
      console.group(`🔵 Stripe: ${operation}`);
      console.log('Data:', data);
      console.trace('Stack trace');
      console.groupEnd();
    }
  },

  // Log payment flow steps
  logPaymentStep: (step: string, data?: any) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`🟢 Payment Step: ${step}`, data);
    }
  },

  // Log errors with context
  logError: (context: string, error: any) => {
    if (process.env.NODE_ENV === 'development') {
      console.error(`🔴 Error in ${context}:`, error);
      console.trace('Stack trace');
    }
  }
};

// Debug configuration
export const DEBUG_CONFIG = {
  // Enable/disable specific debug features
  enableStripeLogging: true,
  enablePaymentFlowLogging: true,
  enableErrorLogging: true,
  
  // Breakpoint triggers
  breakOnStripeConfirm: false,
  breakOnPaymentSuccess: false,
  breakOnPaymentError: false,
  
  // Log levels
  logLevel: 'info' as 'debug' | 'info' | 'warn' | 'error'
};

// Usage examples:
// debugStripe.breakpoint('Before stripe.confirmSetup', { clientSecret, elements });
// debugStripe.logStripeOperation('confirmSetup', { result });
// debugStripe.logPaymentStep('Card replacement started', { oldCardId, newCardId });
